
import {Component, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import GridForm from "@/components/general/GridForm.vue";
import {AproconForm} from "@aprocon-software/aprocon-form"
import TransferButton from "@/components/general/TransferButton.vue";
import TransferComponent from "@/components/TransferComponent.vue";
import Bons from "@/views/bons/Bons.vue";
import Sales from "@/views/sales/Sales.vue";
import CashReport from "@/components/CashReport.vue";

import Products from "@/views/products/Products.vue";
import Listen from "@/views/products/Listen.vue";
@Component({
    components: {
        Listen,
        Products,
        TransferComponent, TransferButton, GridForm, AproconForm, Bons, Sales, CashReport},
})
export default class ProductsGrid extends Vue {
    private saved = false;
    @Prop({required: true, default: 'EDIT_ARTIKEL'})
    private formName!: string;
    @Prop({required: true, default: 'BROWSE_ARTIKEL'})
    private gridName!: string;
    @Prop()
    private tabName!: string;
    @Prop({default: false})
    private isTransmitting!: boolean;

    @Prop({default: 0})
    private id!: number;
    private loading = false;
    private formAction: 'Create' | 'View' | 'Update' | 'Delete' = this.disableLocation ? 'View' : 'Update';
    @Ref()
    private gridForm!: GridForm;
    @Ref()
    private form!: AproconForm<any>;
    private singleSelectActions: any[] = [];
    // [{
    //     icon: '<i class="fas fa-print mr-2"></i>',
    //     displayName: 'Drucken',
    //     action: () => alert('print'),
    // }, {
    //     icon: '<i class="fas fa-trash mr-2"></i>',
    //     displayName: 'Stornieren',
    //     action: () => alert('cancel'),
    // }];
    private multiSelectActions: any[] = [];
    // [{
    //     icon: '<i class="fas fa-print mr-2"></i>',
    //     displayName: 'Alle Drucken',
    //     action: () => alert('print all'),
    // }, {
    //     icon: '<i class="fas fa-trash mr-2"></i>',
    //     displayName: 'Alle Stornieren',
    //     action: () => alert('cancel all'),
    // }];
    private get context(): string {
        return `Filiale=${this.$store.getters["Auth/branchId"]}`;
    }

    private get recordId(): string {
        return this.$store.getters["Auth/branchId"];
    }

    private get formNameComp(): string {
        return this.formName;
    }

    private get searchLabel(): string {
        return this.tabName + ' durchsuchen';
    }

    private get disableLocation(): boolean {
        const config = JSON.parse(localStorage.getItem('Auth/userConfig') || '');
        return config.permissions.KASSENDATEN === 0;
    }

    private formObjectChanged() {
        this.loading = false;
    }

    @Watch('branchId')
    private branchChanged() {
        this.$router.go(0);
    }

    private formSaved(): void {
        // workaround to avoid changes dialog
        this.saved = true;
        this.$nextTick(() => {
            this.$router.go(0);
        });
    }
}
